import React, { useState } from "react";

import CSVImporter from "./CSVImporter";
import { toastSuccess } from "../../shared/toastHelper";

const DEPOSIT_ID_TYPE = "CSVImportRows::VictoryLivePayout";

const AdminCSVImporterContainer = ({
  csrfToken,
  team,
  importerKey,
  type,
  depositIdMaxLength,
  giftColumns,
}) => {
  const [depositId, setDepositId] = useState("");
  const additionalParams = type === DEPOSIT_ID_TYPE ? { deposit_id: depositId } : undefined;

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
      width: "100%",
      padding: 20,
      gap: 20,
    }}>
      <h1>Admin CSV Importer</h1>
      {type === DEPOSIT_ID_TYPE && (
        <label style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          Deposit ID (applied to every row in this import)
          <input
            type="text"
            name="deposit_id"
            value={depositId}
            maxLength={depositIdMaxLength}
            onChange={(e) => setDepositId(e.target.value)}
            placeholder="Enter before importing"
          />
        </label>
      )}
      <CSVImporter
        csrfToken={csrfToken}
        team={team}
        importerKey={importerKey}
        type={type}
        additionalParams={additionalParams}
        dynamicColumns={giftColumns}
        onClose={() => {
          setDepositId("");
          toastSuccess("CSV uploaded successfully.");
        }}
        validateUrl={`/admin/teams/${team.id}/csv_import_rows/bulk_validate`}
        createUrl={`/admin/teams/${team.id}/csv_import_rows/bulk_create`}
        renderAnchor={(openModal) => (
          <a href="#" onClick={openModal} className="btn btn-primary">Import {type}</a>
        )}
      />
    </div>
  );
};

export default AdminCSVImporterContainer;
